import PageHeader from '../../components/PageHeader/PageHeader';
import "../Style/style.css";
import { Row, Col, Form, Input, Checkbox, Tabs, Divider } from 'antd';
import CrudButtons from "../../components/CrudButtons/CrudButtons";
import { useState, useLayoutEffect, useRef, useEffect } from 'react';
import { getRights } from "../../redux/actions/userRights.action";
import { useSelector, useDispatch } from 'react-redux';
import { ReadCookie } from '../../utils/readCookie';
import Tables from "../../components/Table/Tables"
import { logColumns, courierServiceColumn } from "../../utils/cols";
import { getLog } from "../../redux/actions/log.action"
import notification from '../../utils/notification'
import { loadCourierService, addCourierService, updateCourierService, deleteCourierService } from '../../redux/actions/courierService.actions';
import { TabTitle } from '../../utils/GeneralFunction';


const { TabPane } = Tabs;

const CourierService = ({ token }) => {
    TabTitle("CourierService")
    const { courierService, userRights, log, } = useSelector(state => state)
    const [minimize, setMinimize] = useState(false);
    const [formState, setFormState] = useState('view');
    const [description, setDescription] = useState('');
    const [form] = Form.useForm();
    const courierServiceInput = useRef(null);
    const [disable, setDisable] = useState(false);
    const [courierServiceObj, setCourierServiceObj] = useState(null);
    const [check, setCheck] = useState(true);
    const dispatch = useDispatch();
    const id = ReadCookie('menuId');



    useEffect(() => {
        dispatch(loadCourierService(token))
    }, [dispatch, token])


    const handleDelete = () => {
        if (courierServiceObj) {

            dispatch(deleteCourierService(token, courierServiceObj.courier_service_id)).then((res) => {
                if (res.type === "DELETE_COURIER_SERVICE_SUCCESS") {
                    notification("success", "Courier Service Deleted", "Record deleted successfully!");
                }
                if (res.type === "DELETE_COURIER_SERVICE_ERROR") {
                    notification("error", res?.payload?.request?.statusText, res?.payload?.data?.data);
                }
                form.setFieldsValue({
                    name: ""
                })
                setDescription("")
                setCourierServiceObj(null)
                setFormState('view')
                dispatch(loadCourierService(token, id))

            })
        }
        setFormState("view")
    }

    useEffect(() => {

        if (courierServiceObj) {
            setFormState('view')
            form.setFieldsValue({
                id: courierServiceObj.courier_service_id,
                name: courierServiceObj.service_name,
                active: courierServiceObj.is_active,

            });

            setDescription(courierServiceObj.service_name)
            setCheck(courierServiceObj.is_active)

        }


    }, [courierServiceObj]);

    useEffect(() => {
        if (description === '') {
            setDisable(true)
        } else {
            setDisable(false)
        }
    }, [description])




    useLayoutEffect(() => {
        dispatch(getRights(token, id)).then((res) => {
            if (res.type === "GET_USER_RIGHTS_SUCCESS") {
                if (!res?.payload.can_add) {
                    setFormState("table")
                }
            }
        });
    }, [])

    useEffect(() => {

        dispatch(getLog(token, { admin_courier_service: "admin_courier_service" }))
    }, [dispatch, token])


    const formSave = async () => {

        await form.validateFields().then((values) => {
            if (formState === "add") {
                dispatch(addCourierService(token, { service_name: description, is_active: check }, id)).then((res) => {

                    if (res.type === "ADD_COURIER_SERVICE_ERROR") {
                        notification("error", "Not Created", res?.payload?.data?.data)
                    }
                    if (res.type === "ADD_COURIER_SERVICE_SUCCESS") {
                        notification("success", "Courier Service Created", "Courier Service created successfully!");
                        form.setFieldsValue({
                            name: ""
                        })
                        setFormState("view")
                        setDescription("")
                        setCourierServiceObj(null)
                    }
                    dispatch(loadCourierService(token, id))
                })
            }
            if (formState === "edit") {
                dispatch(updateCourierService(token, { service_name: description, is_active: check }, courierServiceObj.courier_service_id)).then((res) => {

                    if (res.type === "UPDATE_COURIER_SERVICE_ERROR") {
                        notification("error", "Not update", "Something went wrong")
                    }
                    if (res.type === "UPDATE_COURIER_SERVICE_SUCCESS") {
                        notification("success", "Courier Service Updated", "Record updated successfully")
                    }
                    dispatch(loadCourierService(token, id))
                })
            }

        }).catch((err) => {

        })
    }

    useEffect(() => {
        if (formState === "add") {
            courierServiceInput.current.focus()
            form.setFieldsValue({
                id: null,
                name: null,
            })
            setCheck(true)
            setDescription("")
            setCourierServiceObj(null)
        }
    }, [formState]);
    const filterReset = () => {
        setFormState("view")
        setCourierServiceObj(null)
        setCheck(true)
        form.setFieldsValue({
            id: null,
            name: null,
        })
        setDescription(null)
    }


    return (
        <div className='styleContainer'>
            <div className='styleBody h-100' >
                <PageHeader title={"Courier Service"} minimize={setMinimize} check={minimize} />
                {
                    !minimize &&
                    <div className='bodyStyle' >
                        <div className='crudDiv' ><CrudButtons formType={formState} rights={userRights?.payload} formState={setFormState} disable={disable} reset={filterReset} save={formSave} onDelete={handleDelete} /></div>
                        <div className='styleContent' >
                            <Row className='tables-main-row-new' >
                                <Col xs={24} sm={24} md={10} lg={8} xl={6}>
                                    <div className='styleTable' >
                                        <Tables type="courierService" formState={formState} scrollX={"20rem"} courierServiceObj={setCourierServiceObj} source={courierService?.payload?.data} col={courierServiceColumn} paginate scroll={500} perPage={25} load={courierService.loading} rowKey="bergan_billing_id" />
                                    </div>
                                </Col>
                                <Col xs={24} sm={24} md={14} lg={16} xl={18}>
                                    <div className='styleForm'  >
                                        <div className='testStyle' >
                                            <Form
                                                form={form}
                                                name="basic"
                                            

                                            >
                                                <div className='customRow styleFormUpper ' >
                                                    {courierServiceObj !== null && !(formState === "add") &&
                                                        <div className='customCols slc'>
                                                            <Form.Item
                                                                label="ID"
                                                                name="id"
                                                                initialValue={form.getFieldValue().id}
                                                                labelCol={{ span: 10 }}
                                                                wrapperCol={{ span: 14 }}

                                                            >
                                                                <Input size='small' className='styleInput id-field-style' readOnly />

                                                            </Form.Item>
                                                        </div>
                                                    }

                                                    <div className='customCols slc'>
                                                        <Form.Item
                                                            label="Service Name"
                                                            name="name"
                                                            initialValue={form.getFieldValue().desc}
                                                            labelCol={{ span: 10 }}
                                                            wrapperCol={{ span: 14 }}
                                                        >

                                                            <Input size='small' disabled={!(formState === "add" || formState === "edit")} ref={courierServiceInput} onChange={(e) => setDescription(e.target.value)} className='styleInput' />
                                                        </Form.Item>
                                                    </div>
                                                    <div className='customCols slc'>
                                                        <Form.Item
                                                            label="Active"
                                                            name="active"
                                                            labelCol={{ span: 10 }}
                                                            wrapperCol={{ span: 14 }}
                                                        >
                                                            <Checkbox disabled={!(formState === "add" || formState === "edit")} checked={check} onChange={(e) => setCheck(e.target.checked)} />
                                                        </Form.Item>
                                                    </div>
                                                </div>
                                            </Form>
                                        </div>

                                        <div className='modalStyle' >


                                        </div>
                                        <Divider />
                                        <div className='styleTab' >
                                            <Tabs type='card' tabBarGutter={2} defaultActiveKey="1" centered  >
                                                <TabPane tab="Log Info" key="logs"  >
                                                    <div className='tabs' >
                                                        <Tables type="company" scrollX={"50rem"} scroll={800} perPage={10} source={log?.payload?.data} col={logColumns} load={log.loading} paginate />
                                                    </div>
                                                </TabPane>
                                            </Tabs>
                                        </div>
                                    </div>

                                </Col>
                            </Row>
                        </div>
                    </div>
                }
            </div>
        </div>





    )
}


export default CourierService